import React, { useState, useEffect } from 'react';
import { useAdminAuth } from '../context/AdminAuthContext';
import { getAdminPlans, addAdminPlan, updateAdminPlan, deleteAdminPlan } from '../api/adminApi';

function formatNumber(num) {
  return new Intl.NumberFormat('fa-IR').format(num);
}

export const AdminPlans = () => {
  const { token } = useAdminAuth();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [titleInput, setTitleInput] = useState('');
  const [durationInput, setDurationInput] = useState('');
  const [priceInput, setPriceInput] = useState('');

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const loadPlans = async () => {
    setLoading(true);
    const result = await getAdminPlans(token);
    setLoading(false);

    if (result.success) {
      setPlans(result.data.plans);
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  useEffect(() => {
    loadPlans();
    // eslint-disable-next-line
  }, []);

  const openAddModal = () => {
    setEditingId(null);
    setTitleInput('');
    setDurationInput('');
    setPriceInput('');
    setShowModal(true);
  };

  const openEditModal = (plan) => {
    setEditingId(plan.id);
    setTitleInput(plan.title);
    setDurationInput(plan.duration_days);
    setPriceInput(plan.price);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!titleInput.trim() || !durationInput || !priceInput) {
      setToast({ show: true, type: 'error', message: 'لطفا همه فیلدها را پر کنید.' });
      return;
    }

    const result = editingId
      ? await updateAdminPlan(token, editingId, titleInput, durationInput, priceInput)
      : await addAdminPlan(token, titleInput, durationInput, priceInput);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      setShowModal(false);
      loadPlans();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const handleDelete = async () => {
    if (!deleteTarget) return;
    const result = await deleteAdminPlan(token, deleteTarget.id);
    setDeleteTarget(null);

    if (result.success) {
      setToast({ show: true, type: 'success', message: result.data.message });
      loadPlans();
    } else {
      setToast({ show: true, type: 'error', message: result.message });
    }
  };

  const inputStyle = {
    border: '1px solid white',
    backgroundColor: 'transparent',
    color: 'white',
    borderRadius: 8,
    height: 40,
    width: '100%'
  };

  return (
    <div dir="rtl" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 className="w3-text-white">مدیریت پلن‌های عضویت</h2>
        <button
          onClick={openAddModal}
          className="w3-button w3-round-xxlarge"
          style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}
        >
          <i className="material-icons w3-margin-left">add</i>
          افزودن پلن جدید
        </button>
      </div>

      <div className="w3-card-4 w3-round-large" style={{ backgroundColor: '#263238', padding: 10 }}>
        {loading ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>در حال بارگذاری...</p>
        ) : plans.length === 0 ? (
          <p className="w3-text-grey w3-center" style={{ padding: 30 }}>هیچ پلنی ثبت نشده است.</p>
        ) : (
          <table className="w3-table w3-text-white" style={{ width: '100%' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #37474F' }}>
                <th style={{ textAlign: 'right', padding: 10 }}>عنوان پلن</th>
                <th style={{ textAlign: 'right', padding: 10 }}>مدت (روز)</th>
                <th style={{ textAlign: 'right', padding: 10 }}>قیمت (تومان)</th>
                <th style={{ textAlign: 'left', padding: 10 }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan) => (
                <tr key={plan.id} style={{ borderBottom: '1px solid #263238' }}>
                  <td style={{ padding: 10 }}>{plan.title}</td>
                  <td style={{ padding: 10 }}>{formatNumber(plan.duration_days)} روز</td>
                  <td style={{ padding: 10, color: '#4FC3F7' }}>{formatNumber(plan.price)}</td>
                  <td style={{ padding: 10, textAlign: 'left' }}>
                    <button onClick={() => openEditModal(plan)} className="w3-button" style={{ color: '#4FC3F7' }}>
                      <i className="material-icons">edit</i>
                    </button>
                    <button onClick={() => setDeleteTarget(plan)} className="w3-button" style={{ color: '#ff0000' }}>
                      <i className="material-icons">delete</i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* مودال افزودن/ویرایش */}
      {showModal && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 380, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ borderBottom: '1px solid #37474F' }}>
              <span onClick={() => setShowModal(false)} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{editingId ? 'ویرایش پلن' : 'افزودن پلن جدید'}</h4>
            </div>
            <div className="w3-container w3-padding">
              <label className="w3-text-white">عنوان پلن</label>
              <input
                type="text"
                value={titleInput}
                onChange={(e) => setTitleInput(e.target.value)}
                placeholder="مثلاً: یک ماه"
                className="w3-input"
                style={{ ...inputStyle, marginBottom: 12 }}
              />

              <label className="w3-text-white">مدت زمان (روز)</label>
              <input
                type="number"
                value={durationInput}
                onChange={(e) => setDurationInput(e.target.value)}
                placeholder="مثلاً: 30"
                className="w3-input"
                style={{ ...inputStyle, marginBottom: 12 }}
              />

              <label className="w3-text-white">قیمت (تومان)</label>
              <input
                type="number"
                value={priceInput}
                onChange={(e) => setPriceInput(e.target.value)}
                placeholder="مثلاً: 149000"
                className="w3-input"
                style={inputStyle}
              />
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={handleSave}
                className="w3-button w3-block"
                style={{ color: '#15ff00', border: '2px solid #2980b9', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      )}

      {/* تایید حذف */}
      {deleteTarget && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 340, maxWidth: '90%', overflow: 'hidden' }}>
            <div className="w3-container w3-padding" style={{ backgroundColor: '#ff000022', borderBottom: '2px solid #ff0000' }}>
              <h4 className="w3-text-white" style={{ margin: 0 }}>تایید حذف</h4>
            </div>
            <div className="w3-container w3-padding">
              <p className="w3-text-white">آیا از حذف پلن «{deleteTarget.title}» مطمئن هستید؟</p>
            </div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16, display: 'flex', gap: 10 }}>
              <button onClick={handleDelete} className="w3-button" style={{ flex: 1, color: 'white', backgroundColor: '#ff0000', borderRadius: 10 }}>
                بله، حذف شود
              </button>
              <button
                onClick={() => setDeleteTarget(null)}
                className="w3-button"
                style={{ flex: 1, color: '#15ff00', border: '2px solid #15ff00', backgroundColor: 'transparent', borderRadius: 10 }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* پیام موفقیت/خطا */}
      {toast.show && (
        <div className="w3-modal" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 999 }}>
          <div className="w3-card-4 w3-animate-zoom" style={{ backgroundColor: '#263238', borderRadius: 16, width: 320, maxWidth: '90%', overflow: 'hidden' }}>
            <div
              className="w3-container w3-padding"
              style={{
                backgroundColor: toast.type === 'success' ? '#15ff0022' : '#ff000022',
                borderBottom: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`
              }}
            >
              <span onClick={() => setToast({ ...toast, show: false })} className="w3-button w3-display-topright" style={{ color: 'white' }}>&times;</span>
              <h4 className="w3-text-white" style={{ margin: 0 }}>{toast.type === 'success' ? '✅ موفقیت' : '❌ خطا'}</h4>
            </div>
            <div className="w3-container w3-padding"><p className="w3-text-white">{toast.message}</p></div>
            <div className="w3-container w3-padding" style={{ paddingBottom: 16 }}>
              <button
                onClick={() => setToast({ ...toast, show: false })}
                className="w3-button w3-block"
                style={{ color: toast.type === 'success' ? '#15ff00' : '#ff0000', border: `2px solid ${toast.type === 'success' ? '#15ff00' : '#ff0000'}`, backgroundColor: 'transparent', borderRadius: 10 }}
              >
                باشه
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};